import Vue from "vue";
import Router from "vue-router";
import Layout from "@/views/layout";
import Home from "@/views/home";

Vue.use(Router);

export const constantRouterMap = [
  {
    path: "/",
    // meta: {
    //   content: {
    //     keywords: "先农氏,智能碾米机,先农氏智能无人碾米。",
    //     description:
    //       "先农氏智能无人碾米机，中国首台智能无人碾米机，专利产品。拥有先进核心技术，更智能、碾米速度更快，噪音更小，操作更简便，现碾现售。新鲜，安全，营养。"
    //   }
    // },
    component: Layout,
    children: [
      {
        path: "",
        name: "home",
        component: Home
      },
      {
        path: "product/:id",
        name: "product",
        component: () => import("@/views/product")
      },
      {
        path: "product-detail/:id",
        name: "product-detail",
        component: () => import("@/views/product/detail"),
        meta: {
          parent: "product"
        }
      },
      {
        path: "solution/:id",
        name: "solution",
        component: () => import("@/views/product/solution"),
        meta: {
          parent: "product"
        }
      },
      {
        path: "application/:id",
        name: "application",
        component: () => import("@/views/product/application"),
        meta: {
          parent: "product"
        }
      },
      {
        path: "cloud/:id",
        name: "cloud",
        component: () => import("@/views/cloud")
      },
      {
        path: "case/:id",
        name: "case",
        component: () => import("@/views/case")
      },

      {
        path: "program/index",
        name: "index",
        component: () => import("@/views/program/index")
      },
      {
        path: "case-detail/:id",
        name: "case-detail",
        component: () => import("@/views/case/detail"),
        meta: {
          parent: "case"
        }
      },
      {
        path: "trend/:id",
        name: "trend",
        component: () => import("@/views/trend"),
        meta: {
          parent: "home"
        }
      },
      {
        path: "trend-detail/:id",
        name: "trend-detail",
        component: () => import("@/views/trend/detail"),
        meta: {
          parent: "home"
        }
      },
      {
        path: "train",
        name: "train",
        component: () => import("@/views/train"),
        meta: {
          parent: "about"
        }
      },

      {
        path: "train-detail/:id",
        name: "train-detail",
        component: () => import("@/views/train/detail"),
        meta: {
          parent: "home"
        }
      },
      {
        path: "about/:id",
        name: "about",
        component: () => import("@/views/about")
      },
      {
        path: "financial",
        name: "financial",
        component: () => import("@/views/financial")
      },
      {
        path: "unitControl",
        name: "unitControl",
        component: () => import("@/views/unitControl")
      },
      {
        path: "appli",
        name: "appli",
        component: () => import("@/views/appli")
      },
      {
        path: "budgetPerformance",
        name: "budgetPerformance",
        component: () => import("@/views/program/components/budgetPerformance")
      },
      {
        path: "program-unitControl",
        name: "program-unitControl",
        component: () =>
          import("@/views/program/components/program-unitControl")
      },
      {
        path: "assetManagement",
        name: "assetManagement",
        component: () => import("@/views/program/components/assetManagement")
      },
      {
        path: "financialAccounting",
        name: "financialAccounting",
        component: () =>
          import("@/views/program/components/financialAccounting")
      },
      {
        path: "cooperation",
        name: "cooperation",
        component: () => import("@/views/cooperation/index")
      }
    ]
  },
  {
    path: "*",
    redirect: "/"
  }
];

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});
